import Dexie from 'dexie';
import type { CacheEntry } from './cache.types.ts';

export class CacheDatabase extends Dexie {
  apiCache!: Dexie.Table<CacheEntry, string>;

  constructor(dbName: string) {
    super(dbName);

    this.version(1).stores({
      apiCache: 'key, timestamp',
    });
  }
}
